import { resolveWidgetKind } from '../helpers';
import { CheckboxField } from './CheckboxField';
import { CounterField } from './CounterField';
import { DateField } from './DateField';
import { DateTimeField } from './DateTimeField';
import { DecimalField } from './DecimalField';
import { GeoCodeField } from './GeoCodeField';
import { LocationField } from './LocationField';
import { MultiSelectField } from './MultiSelectField';
import { NumberField } from './NumberField';
import { SearchField } from './SearchField';
import { SingleLineTextField } from './SingleLineTextField';
import { SingleSelectField } from './SingleSelectField';
import { TimeIntervalField } from './TimeIntervalField';
import { UnsupportedField } from './UnsupportedField';
import { VersionedImagePickerField } from './VersionedImagePickerField';
import { VersionedPdfPickerField } from './VersionedPdfPickerField';
import { WeekPickerField } from './WeekPickerField';
import { YearPickerField } from './YearPickerField';
import type { FieldComponentProps } from './types';

export const FieldRenderer = (props: FieldComponentProps) => {
  const kind = resolveWidgetKind(props.field);
  switch (kind) {
    case 'SingleLineText':
      return <SingleLineTextField {...props} />;
    case 'Number':
      return <NumberField {...props} />;
    case 'Decimal':
      return <DecimalField {...props} />;
    case 'Date':
      return <DateField {...props} />;
    case 'datetime':
      return <DateTimeField {...props} />;
    case 'week_picker':
      return <WeekPickerField {...props} />;
    case 'year_picker':
      return <YearPickerField {...props} />;
    case 'time_interval_picker':
      return <TimeIntervalField {...props} />;
    case 'Checkbox':
      return <CheckboxField {...props} />;
    case 'SingleSelect':
      return <SingleSelectField {...props} />;
    case 'MultiSelect':
      return <MultiSelectField {...props} />;
    case 'Search':
      return <SearchField {...props} />;
    case 'counter':
      return <CounterField {...props} />;
    case 'geo_code':
      return <GeoCodeField {...props} />;
    case 'versioned_image_picker':
      return <VersionedImagePickerField {...props} />;
    case 'versioned_pdf_picker':
      return <VersionedPdfPickerField {...props} />;
    case 'location':
      return <LocationField {...props} />;
    case 'unsupported':
    default:
      return <UnsupportedField {...props} />;
  }
};
